import * as moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const parseDate = strDate =>
  moment(`${strDate}`).format('MMMM Do YYYY, h:mm:ss a');

export { parseDate };
